import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './index.css';
import './fonts.css';
import App from './views/app/App';
import * as serviceWorker from './serviceWorker';
import {setAxiosSettings} from './utils/api'
import {setDefaultLang} from './utils/lang/common'
import configureStore from './store/configureStore'
import { Provider } from 'react-redux';


setDefaultLang();
const store = configureStore();
setAxiosSettings(store);


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
